// FillingData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string;
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const filling: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    en: {
        "url": "",
        "meta": {
            "title": "Tooth Filling Dubai",
            "description": "Professional tooth filling services in Dubai to treat cavities and restore your smile. We use composite, amalgam, and gold fillings for durable, natural-looking results.",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["Home", "Services", "Tooth Filling Dubai"],
        "hero": {
            "title": "Tooth Filling Dubai",
            "subtitle": "Revive Your Smile with Precision Restorations!",
            "description": "Dental cavities also known as tooth decay is one of the most prevalent oral health conditions, affecting both children and adults, causing discomfort, and leading to complications if left untreated. We provide Tooth Filling Dubai services to help restore function and aesthetics to your smile due to cavities at Elite Body Home Polyclinic."
        },
        "howItWorks": {
            "title": "Why Choose Tooth Fillings?",
            "description": "Tooth fillings are used to repair cavities and small areas of tooth damage, restoring the strength and functionality of the tooth. They help stop the academic rot, eradicates discomfort, and allows you to eat, speak, and smile confidently."
        },
        "procedureSteps": {
            "heading": "Procedure For Dental Filling",
            "para": "Dental filling is a painless procedure aimed to be done in a single dental visit.",
            "steps": [
                {
                    "title": "Examination and X-rays",
                    "desc": "Our dentists conduct an exhaustive inspection of your teeth, frequently using X-rays to identify cavities, before the method.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "Numbing the Area",
                    "desc": "Local anesthesia is used to numb the tooth and its surrounding area to make the procedure pain free.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Removing Decay",
                    "desc": "It is carefully excavated with specialized dental tools.",
                    "icon": "fa-solid fa-tooth"
                },
                {
                    "title": "Cleaning the Area",
                    "desc": "Then cleaning the area of bacteria and lacerations to make it sterile.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Filling the Tooth",
                    "desc": "A selected material (a composite resin, amalgam, or gold) fills the cleaned cavity. That seals the tooth up and strengthens it.",
                    "icon": "fa-solid fa-fill-drip"
                },
                {
                    "title": "Shaping & Polishing",
                    "desc": "The filling is then shaped to match the natural contours of the tooth and polished smooth for comfort.",
                    "icon": "fa-solid fa-sparkles"
                }
            ]
        },
        "benefits": {
            "heading": "Advantages of Teeth Filling Dubai",
            "subheading": "",
            "para": "Tooth fillings provide many advantages, ranging from maintaining the natural structure of the tooth to avoiding more invasive treatments.",
            "items": [
                {
                    "title": "Restoration of Tooth Function",
                    "desc": "Fillings allow your tooth to perform its function properly so that you can chew and speak without trouble.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Prevention of Further Decay",
                    "desc": "Fillings stop the decay from spreading by sealing up the cavity.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Protection of Tooth Structure",
                    "desc": "They help shield the health remaining healthy tooth structure from further damage.",
                    "icon": "fa-solid fa-lock"
                },
                {
                    "title": "Improvement in Aesthetics",
                    "desc": "Tooth-colored fillings match your natural teeth, enhancing your smile.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "eligibility": {
            "heading": "Symptoms of Tooth Decay",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Tooth Sensitivity",
                    "desc": "",
                    "icon": "fa-solid fa-temperature-low"
                },
                {
                    "title": "Toothache or Pain",
                    "desc": "",
                    "icon": "fa-solid fa-toothache"
                },
                {
                    "title": "Visible Holes or Pits",
                    "desc": "",
                    "icon": "fa-solid fa-circle"
                },
                {
                    "title": "Discoloration",
                    "desc": "",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "Bad Breath",
                    "desc": "",
                    "icon": "fa-solid fa-wind"
                },
                {
                    "title": "Swelling or Bleeding Gums",
                    "desc": "",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Pain When Biting or Chewing",
                    "desc": "",
                    "icon": "fa-solid fa-bite"
                }
            ]
        },
        "preparationTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Tooth fillings can relieve the pain immediately and restore the function of the tooth.",
            "items": [
                {
                    "title": "Immediate Functionality",
                    "desc": "Once the anesthetic wears off, you'll be able to chew and speak normally.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "Improved Oral Health",
                    "desc": "The filling stops the decay process, and protects the tooth from infection.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Enhanced Appearance",
                    "desc": "Because tooth-colored fillings are made of a material that mimics the appearance of your teeth, they're often used to enhance your smile.",
                    "icon": "fa-solid fa-grin"
                },
                {
                    "title": "Long-lasting Durability",
                    "desc": "Fillings can last for many years with the proper care, keeping your teeth and gums healthy.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Post-Dental Filling Care",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Eating After Procedure",
                    "desc": "Eat only after the numbness wears off, or you risk taking a bite out of the wrong thing.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Chewing Precautions",
                    "desc": "Do not chew on the side with the new filling for 24 hours, especially with metal amalgam fillings.",
                    "icon": "fa-solid fa-teeth-open"
                },
                {
                    "title": "Sensitivity Management",
                    "desc": "You may experience some sensitivity to hot, cold or sweet foods; toothpaste for sensitive teeth can help if that happens.",
                    "icon": "fa-solid fa-temperature-low"
                },
                {
                    "title": "Oral Hygiene",
                    "desc": "Be sure to brush twice a day, and floss gently around the filling, not brushing too hard.",
                    "icon": "fa-solid fa-toothbrush"
                },
                {
                    "title": "Food Restrictions",
                    "desc": "Limit hard or sticky foods that may chip or dislodge the filling, especially immediately after the procedure.",
                    "icon": "fa-solid fa-candy-cane"
                },
                {
                    "title": "Follow-up Care",
                    "desc": "If the filling feels rough or your bite feels uneven, call the dentist for an adjustment.",
                    "icon": "fa-solid fa-phone"
                },
                {
                    "title": "Regular Check-ups",
                    "desc": "Regular dental check-ups will help in evaluating the condition of the filling, as well as ensure oral health.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    question: "Is tooth extraction painful?",
                    answer:
                        "Local anesthesia or sedation ensures the procedure is painless. You may experience mild discomfort afterward, but it is manageable with over-the-counter pain medications.",
                },
                {
                    question: "How long does it take to recover from a tooth extraction?",
                    answer:
                        "Most patients recover within 1-2 weeks. For surgical extractions, recovery may take a bit longer, especially for impacted wisdom teeth.",
                },
                {
                    question: "What can I eat after a tooth extraction?",
                    answer:
                        "Soft foods such as yogurt, mashed potatoes, and smoothies are recommended for the first few days. Avoid chewing near the extraction site to promote healing.",
                },
                {
                    question: "Can I brush my teeth after an extraction?",
                    answer:
                        "You can brush your teeth, but avoid the extraction site for the first 24 hours to prevent dislodging the blood clot. After 24 hours, gently rinse your mouth with salt water.",
                },
            ]
        },
        "treatmentAreas1": [
            {
                "ar": "الحشو المركب",
                "title": "Gold Fillings",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Dental-Care-in-Dubai-4-large.jpg"
            },
            {
                "ar": "حشو الفضة أو الملغم",
                "title": "Amalgam/Silver Fillings",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Dental-Care-in-Dubai-3.jpg"
            },
            {
                "ar": "حشو الذهب",
                "title": "Composite Fillings",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Dental-Care-in-Dubai-4-large.jpg"
            }
        ],
        "treatmentAreas2": [
        ]
    },
    ar: {
        "url": "",
        "meta": {
            "title": "حشو الأسنان في دبي",
            "description": "خدمات حشو الأسنان في ايليت بودي هوم بدبي باستخدام أحدث المواد مثل الحشوات المركبة والسيراميكية لنتائج متينة وطبيعية.",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "حشو الأسنان في دبي"],
        "hero": {
            "title": "حشو الأسنان في دبي",
            "subtitle": "استعد ابتسامتك مع ترميم دقيق وفعال",
            "description": "يُعد تسوس الأسنان أو تجاويف الأسنان من أكثر مشكلات الفم شيوعًا بين الأطفال والبالغين، وقد تسبب إزعاجًا ومضاعفات إذا تركت دون علاج. نوفر خدمات حشو الأسنان في ايليت بودي هوم بدبي، لمساعدتك على استعادة وظيفة الأسنان ومظهر الابتسامة المتأثرين بالتسوس."
        },
        "howItWorks": {
            "title": "لماذا يُنصح بحشوات الأسنان؟",
            "description": "تُستخدم حشوات الأسنان لإصلاح الأسنان التالفة، مما يعيد لها قوتها ووظيفتها. تُسهم الحشوات في إيقاف تدهور السن والتآكل التدريجي، وتخفيف الألم، وملء التجاويف، لتمنحك راحة أثناء تناول الطعام، والتحدث، والابتسام بثقة."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء حشو الأسنان",
            "para": "يُعد حشو الأسنان إجراء غير مؤلم، يُجرى غالبًا خلال زيارة واحدة لطبيب الأسنان.",
            "steps": [
                {
                    "title": "الفحص والتصوير بالأشعة السينية",
                    "desc": "يقوم طبيب الأسنان بإجراء فحص دقيق، وغالبًا ما يستخدم الأشعة السينية للكشف عن المناطق المتضررة بدقة.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "التخدير الموضعي",
                    "desc": "يتم تخدير السن والمنطقة المحيطة باستخدام مخدر موضعي لضمان راحة المريض وعدم شعوره بأي ألم أثناء الإجراء.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "إزالة التسوس",
                    "desc": "يُزال التسوس من السن بدقة باستخدام أدوات مخصصة.",
                    "icon": "fa-solid fa-tooth"
                },
                {
                    "title": "تنظيف المنطقة",
                    "desc": "تُنظف المنطقة المعالجة من البكتيريا والشوائب، لضمان بيئة معقمة قبل وضع الحشوة.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "وضع الحشوة",
                    "desc": "يتم ملء التجويف المُنظف بالحشوة المختارة (المركبة، أو الملغم، أو الذهب)، حيث تعمل الحشوة على سد الفجوة وتقوية السن.",
                    "icon": "fa-solid fa-fill-drip"
                },
                {
                    "title": "التشكيل والتلميع",
                    "desc": "يقوم الطبيب بتشكيل الحشوة لتتناسب مع شكل السن الطبيعي وتنعيم سطحها لضمان راحة الفم وسهولة المضغ.",
                    "icon": "fa-solid fa-sparkles"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد حشو الأسنان في دبي",
            "subheading": "",
            "para": "تُوفر حشوات الأسنان العديد من الفوائد، بدءًا من الحفاظ على البنية الطبيعية للسن وصولًا إلى تجنب الحاجة إلى طرق علاج أكثر تدخلًا.",
            "items": [
                {
                    "title": "استعادة وظيفة السن",
                    "desc": "يساعد الحشو على مضغ الطعام والتحدث بشكل طبيعي.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "منع تطور التسوس",
                    "desc": "تمنع الحشوات انتشار التسوس إلى باقي السن أو الأسنان المجاورة من خلال غلق التجاويف.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "حماية بنية السن",
                    "desc": "يُحافظ الحشو على ما تبقّى من السن ويمنع تآكله.",
                    "icon": "fa-solid fa-lock"
                },
                {
                    "title": "تحسين الشكل الجمالي",
                    "desc": "تُستخدم حشوات بلون الأسنان مثل الكمبوزيت او المركبة، للحصول على ابتسامة طبيعية ومتناسقة.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "eligibility": {
            "heading": "أعراض تسوس الأسنان",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "حساسية الأسنان",
                    "desc": "",
                    "icon": "fa-solid fa-temperature-low"
                },
                {
                    "title": "ألم في الأسنان",
                    "desc": "",
                    "icon": "fa-solid fa-toothache"
                },
                {
                    "title": "وجود ثقوب أو فجوات",
                    "desc": "",
                    "icon": "fa-solid fa-circle"
                },
                {
                    "title": "تغير لون الأسنان",
                    "desc": "",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "رائحة فم كريهة",
                    "desc": "",
                    "icon": "fa-solid fa-wind"
                },
                {
                    "title": "نزيف أو تورم اللثة",
                    "desc": "",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "ألم عند المضغ أو العض",
                    "desc": "",
                    "icon": "fa-solid fa-bite"
                }
            ]
        },
        "preparationTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يمكن لحشوات الأسنان أن تخفف الألم على الفور وتعيد للسن وظيفته بالكامل.",
            "items": [
                {
                    "title": "استعادة الوظيفة فورًا",
                    "desc": "يمكنك المضغ والتحدث بشكل طبيعي، بمجرد زوال مفعول التخدير.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "تحسن في صحة الفم",
                    "desc": "يعمل الحشو على إيقاف انتشار التسوس ويحمي السن من العدوى.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "تحسن المظهر الجمالي",
                    "desc": "تُصنع الحشوات من مواد تُشبه لون الأسنان الطبيعي، مما يجعلها مثالية لتعزيز ابتسامتك.",
                    "icon": "fa-solid fa-grin"
                },
                {
                    "title": "متانة تدوم لسنوات",
                    "desc": "مع العناية الجيدة، يمكن أن تدوم الحشوة لسنوات طويلة، مما يحافظ على صحة الأسنان واللثة.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "aftercareTips": {
            "heading": "العناية بعد حشو الأسنان",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "تناول الطعام بعد التخدير",
                    "desc": "لا تتناول الطعام إلا بعد زوال تأثير التخدير لتجنب عض اللسان دون قصد.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "تجنب المضغ على الجانب المعالج",
                    "desc": "تجنب المضغ على الجانب الذي تم فيه الحشو لمدة 24 ساعة، خاصةً إذا كانت الحشوة من الملغم المعدني.",
                    "icon": "fa-solid fa-teeth-open"
                },
                {
                    "title": "إدارة الحساسية",
                    "desc": "قد تشعر بحساسية تجاه الأطعمة الساخنة أو الباردة أو الحلويات، ويمكن استخدام معجون الأسنان المخصص للأسنان الحساسة للتخفيف من ذلك.",
                    "icon": "fa-solid fa-temperature-low"
                },
                {
                    "title": "النظافة الفموية",
                    "desc": "احرص على تنظيف الأسنان بالفرشاة مرتين يوميًا، مع استخدام الخيط برفق حول الحشوة، وتجنب الفرك القوي.",
                    "icon": "fa-solid fa-toothbrush"
                },
                {
                    "title": "تجنب الأطعمة الصلبة",
                    "desc": "قلل من تناول الأطعمة الصلبة أو اللزجة التي قد تُسبب تكسر الحشوة أو انفصالها، خاصةً بعد الإجراء مباشرةً.",
                    "icon": "fa-solid fa-candy-cane"
                },
                {
                    "title": "ضبط الحشوة إذا لزم الأمر",
                    "desc": "إذا شعرت بأن الحشوة خشنة أو أن الإطباق غير متوازن، تواصل مع طبيب الأسنان لضبطها.",
                    "icon": "fa-solid fa-phone"
                },
                {
                    "title": "الزيارات الدورية",
                    "desc": "تساعد زيارات المتابعة الدورية لطبيب الأسنان في تقييم حالة الحشوة وضمان صحة الفم بشكل عام.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "",
            "subheading": "",
            "items": []
        },
        "treatmentAreas1": [
            {
                "ar": "الحشو المركب",
                "title": "Gold Fillings",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Dental-Care-in-Dubai-4-large.jpg"
            },
            {
                "ar": "حشو الفضة أو الملغم",
                "title": "Amalgam/Silver Fillings",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Dental-Care-in-Dubai-3.jpg"
            },
            {
                "ar": "حشو الذهب",
                "title": "Composite Fillings",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Dental-Care-in-Dubai-4-large.jpg"
            }
        ],
        "treatmentAreas2": []
    },
    shared: {
        images: {
            main: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/dental-services-in-dubai-3-scaled.jpg",
            beforeAfter: [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Before-After-Service-Images-11.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Before-After-Service-Images-12.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Before-After-Service-Images-13.jpg"
            ],
            introductionImage: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Dental-Care-in-Dubai-4-large.jpg"
        },
        product: {
            id: 1,
            title: "Tooth Filling",
            price: 100,
            description: "Professional tooth filling services in Dubai to treat cavities and restore your smile. We use composite, amalgam, and gold fillings for durable, natural-looking results."
        }
    }
};
